export const instantSearch = SAXX.Init.Component((node) => {
  const input = node.querySelector('[name="q"]')
  const resultsContainer = node.querySelector(
    '.instant-search--results-container',
  )

  const pendingSearchRequests = new WeakMap()

  const inputEventListener = (e) => {
    const rawQuery = e.target.value

    if (!rawQuery.length) {
      resultsContainer.innerHTML = ''
      input.parentNode.classList.remove('loading')
      return
    }

    const previousController = pendingSearchRequests.get(e)
    if (previousController) {
      previousController.abort()
    }

    const controller = new AbortController()
    pendingSearchRequests.set(e, controller)

    const searchTerm = rawQuery.trim()
    const lastTerm = searchTerm.split(' ').pop()

    Promise.allSettled([
      fetch(
        `${window.Shopify.routes.root}search?q=${searchTerm}&type=product&section_id=semantic-search`,
        { signal: controller.signal },
      )
        .then((res) => res.text())
        .catch((error) => {
          if (error.name === 'AbortError') return
          throw error
        }),
      fetch(
        `${window.Shopify.routes.root}search/suggest?q=${lastTerm}&resources[type]=query,collection,page,article&resources[limit]=5&resources[options][fields]=body,product_type,tag,title,variants.title,variants.sku&section_id=predictive-search`,
        { signal: controller.signal },
      )
        .then((res) => res.text())
        .catch((error) => {
          if (error.name === 'AbortError') return
          throw error
        }),
    ])
      .then((response) => {
        if (controller.signal.aborted) throw new Error('Aborted')

        const resolved = response.filter((res) => res.status !== 'rejected')

        if (resolved.length === 0) throw new Error()

        return resolved.reduce((a, c) => {
          if (c.status === 'rejected') return a
          return a + c.value
        }, '')
      })
      .then((response) => {
        if (controller.signal.aborted) throw new Error('Aborted')

        resultsContainer.innerHTML = ''
        const rawHTML = new DOMParser().parseFromString(response, 'text/html')
        const queryResults =
          rawHTML.querySelector('#predictive-search--query-results')
            ?.innerHTML ?? null
        if (queryResults) {
          resultsContainer.insertAdjacentHTML(
            'beforeend',
            `<div class='instant-search--query-results'>${queryResults}</div>`,
          )
        }

        const semanticResults =
          rawHTML.querySelector('#semantic-search--results')?.innerHTML ?? null
        if (semanticResults) {
          resultsContainer.insertAdjacentHTML(
            'beforeend',
            `<div class='instant-search--semantic-results'>${semanticResults}</div>`,
          )
        }

        const pageResults =
          rawHTML.querySelector('#predictive-search--page-results')
            ?.innerHTML ?? null
        if (pageResults) {
          resultsContainer.insertAdjacentHTML(
            'beforeend',
            `<div class='instant-search--page-results'>${pageResults}</div>`,
          )
        }

        if (queryResults || pageResults || semanticResults) {
          resultsContainer.insertAdjacentHTML(
            'beforeend',
            `<div class='instant-search--view-more-results'><a href="${window.Shopify.routes.root}search?q=${searchTerm}" class="button__underline--thick">View more results for '${searchTerm}'</a></div>`,
          )
        }

        resultsContainer.classList.toggle('has-products', !!semanticResults)
        resultsContainer.classList.toggle('has-suggestions', !!queryResults)
        resultsContainer.classList.toggle('has-pages', !!pageResults)
        resultsContainer.classList.toggle(
          'has-results',
          !!semanticResults || !!queryResults || !!pageResults,
        )
        SAXX.App.mount('data-search-component')
      })
      .catch((error) => {
        if (error === 'Aborted') return

        resultsContainer.insertAdjacentHTML(
          'beforeend',
          `<div class='instant-search--error'><strong>${SAXX.Localization.SearchError}</strong></div>`,
        )
      })
      .finally(() => {
        pendingSearchRequests.delete(e)
        input.parentNode.classList.remove('loading')
      })

    setTimeout(() => {
      controller.abort()
      pendingSearchRequests.delete(e)
    }, 1500)
  }

  input.addEventListener('input', () => {
    input.parentNode.classList.add('loading')
  })
  input.addEventListener(
    'input',
    SAXX.Library.Debounce(inputEventListener, 200),
  )
  input.addEventListener('queryUpdate', inputEventListener)
})

export const instantSearchQuery = SAXX.Init.Component((node) => {
  const searchInput = node
    .closest('.instant-search')
    .querySelector('[name="q"]')

  node.addEventListener('click', (e) => {
    if (searchInput.value !== node.getAttribute('data-query')) {
      e.preventDefault()
    }

    searchInput.value = node.getAttribute('data-query')
    searchInput.dispatchEvent(new Event('queryUpdate'))
  })
})
